import React from "react";
import { useAcquireBookForm } from "@/features/acquireBook/hooks/useAcquireBookForm";
import type { ISingleBookAcquireDialogData } from "@/types/singleBookAcquireDialog";
import { AcquireBookFormModal } from "./AcquireBookFormModal";
import { AcquireBookFormPage } from "./AcquireBookFormPage";

interface IProps {
  mode: "modal" | "normal";
  singleBookAcquireDialogData?: ISingleBookAcquireDialogData;
  isReadOnly?: boolean;
  isKaokuNumberSearchModal?: boolean;
  handleClose?: () => void;
}

/**
 * 登記１件取得画面のUI
 * modeを"normal"にするとページ版UIが表示され、"modal"に設定するとモーダル版が表示される
 * modalモードの場合はsingleBookAcquireDialogDataが必要になります。
 * 引数が正しく設定されていない場合は何も表示されません
 * @param props
 */
export const AcquireBookFormUI: React.FC<IProps> = (props) => {
  const {
    mode,
    singleBookAcquireDialogData,
    isReadOnly = true,
    isKaokuNumberSearchModal = true,
    handleClose,
  } = props;

  // 登記取得APIアクセス用関数
  const acquireBookForm = useAcquireBookForm();

  switch (mode) {
    case "normal":
      return <AcquireBookFormPage acquireBookForm={acquireBookForm} />;
    case "modal":
      if (!singleBookAcquireDialogData) return null;
      return (
        <AcquireBookFormModal
          acquireBookForm={acquireBookForm}
          singleBookAcquireDialogData={singleBookAcquireDialogData}
          isReadOnly={isReadOnly}
          isKaokuNumberSearchModal={isKaokuNumberSearchModal}
          handleClose={handleClose}
        />
      );
    default:
      return null;
  }
};
